import { render, staticRenderFns } from "./example1.vue?vue&type=template&id=0c570cf9&"
import script from "./example1.vue?vue&type=script&lang=js&"
export * from "./example1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "example1.vue"
export default component.exports